import React from "react";
import { Project } from "../Project";

export const CreateProjects: React.FC = () => {
  return (
    <>
      <div>
        <Project pageType="create" />
      </div>
    </>
  );
};
